module.exports = __webpack_public_path__ + "img/plus_btn.ca42f53c.png";